import { Box, Typography, useTheme } from "@mui/material";
import { ExchangeSummaryLabel } from "shared-ui/Exchange/SummaryLabel";
import { MacrosSummaryLabel } from "shared-ui/Macros/SummaryLabel";
import { getExchangeAmountsMacros } from "shared-ui/ExchangeAmount/utils";
import { initMacros } from "@notemeal/shared-utils-macro-protocol";
import { formatEventTime } from "@notemeal/utils-date-time";
import { FullMealTemplateFragment } from "../../../../types";
import { isExchange, isMacro } from "../utils";

export interface ExportMealHeaderProps {
  displayExchanges: boolean;
  displayMacros: boolean;
  mealTemplate: FullMealTemplateFragment;
}

export const ExportMealHeader = ({ displayExchanges, displayMacros, mealTemplate }: ExportMealHeaderProps) => {
  const {
    palette: { greyscaleLight },
  } = useTheme();
  const macros =
    mealTemplate && isMacro(mealTemplate) ? initMacros(mealTemplate.cho || 0, mealTemplate.pro || 0, mealTemplate.fat || 0) : null;

  const showMacroSummary = displayMacros && macros;
  const showExchangeSummary = displayExchanges && isExchange(mealTemplate);
  const showExchangeMacroSummary = displayMacros && isExchange(mealTemplate) && mealTemplate.exchangeTargets;

  return (
    <Box sx={{ width: "100%", minWidth: "600px", lineHeight: 1, overflow: "hidden", pb: 1 }}>
      <Box sx={{  px: 1, py:.5, borderLeft: `2px solid ${greyscaleLight[400]}` }}>
        <Box sx={{ display: "flex", flexDirection: "row", width: "100%", minWidth: "600px" }}>
          <Typography
            sx={{ lineHeight: 1, fontSize: "1rem", whiteSpace: "nowrap" }}
            variant="body2Medium"
            color="inherit">
            {mealTemplate.meal.name || ""}
          </Typography>
          <Typography variant="subtitle1" sx={{ pl: 1, lineHeight: 1, fontSize: ".85rem", whiteSpace: "nowrap" }}>
            ({formatEventTime(mealTemplate.meal)})
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", width: "100%", minWidth: "600px", alignItems: "center", lineHeight: 0.8 }}>
          {showExchangeSummary && (
            <ExchangeSummaryLabel
              consolidatePro
              variant="xs"
              targetExchangeAmounts={mealTemplate.exchangeTargets || []} />
          )}
          {showExchangeSummary && (showMacroSummary || showExchangeMacroSummary) && (
            <Typography sx={{ px: 1, fontSize: ".7rem" }}>{" | "}</Typography>
          )}
          {showMacroSummary && <MacrosSummaryLabel
            variant="xs"
            sx={{ fontSize: ".7rem !important" }}
            macros={macros}
            kcalPrefix />}
          {showExchangeMacroSummary && (
            <MacrosSummaryLabel
              kcalPrefix
              variant="xs"
              macros={getExchangeAmountsMacros(mealTemplate.exchangeTargets)} />
          )}
        </Box>
      </Box>
    </Box>
  );
};
